import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { CTALink } from "@/components/ui-kit";

export default function NotFound() {
  return (
    <div className="min-h-[80vh] flex items-center relative z-10">
      <SEO path="/404" title="Page not found" />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <span className="font-data text-sm text-orange">404</span>
        <h1 className="mt-4 font-serif text-5xl md:text-7xl text-navy tracking-tight">Page not found.</h1>
        <p className="mt-5 font-sans text-lg text-slate max-w-md">The page you're looking for isn't here. Let's get you back on track.</p>
        <div className="mt-8"><CTALink to="/" variant="primary" data-testid="notfound-home">Back to home</CTALink></div>
      </div>
    </div>
  );
}
